import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
    name: 'asterisk',
})
export class AsteriskPipe implements PipeTransform {
    transform(value: unknown) {
        return value && value + '*'
    }
}
